// extracted by mini-css-extract-plugin
export default {"title":"Title_title__CmaZW","accent":"Title_accent__QGTLp","alternate":"Title_alternate__pEDyj","large":"Title_large__ncXJt"};